/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { CellPresenterBase } from "./CellPresenterBase";
import { SectionHeaderCellModel } from "./SectionHeaderCellModel";
import { markType } from "igniteui-react-core";
import { ContentCellModelHelper } from "./ContentCellModelHelper";
/**
 * @hidden
 */
var SectionHeaderCellPresenter = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(SectionHeaderCellPresenter, _super);
    function SectionHeaderCellPresenter(a) {
        return _super.call(this, a) || this;
    }
    Object.defineProperty(SectionHeaderCellPresenter.prototype, "d", {
        get: function () {
            return this.a;
        },
        enumerable: true,
        configurable: true
    });
    SectionHeaderCellPresenter.prototype.b = function (a) {
        _super.prototype.b.call(this, a);
        var b = a;
        if (a.as) {
            if (a.ax(SectionHeaderCellModel.k2) || a.ax(SectionHeaderCellModel.k4) || a.ax(SectionHeaderCellModel.k3) || a.ax(SectionHeaderCellModel.k6)) {
                if (b.ky == null || (b.ky.length == 0 && b.lc == null)) {
                    if (b.gp == null) {
                        b.ir = "";
                    }
                    else {
                        b.ir = b.gp.toString();
                    }
                }
                else {
                    if (b.la != null && b.k1 == 0) {
                        b.ir = b.lc + "    " + b.la;
                    }
                    else {
                        b.ir = b.lc;
                    }
                }
                this.d.b9.setRawText(b.ir);
            }
            ContentCellModelHelper.a(this.a.w, b, this.a.z, this.d.b9, this.a);
        }
    };
    SectionHeaderCellPresenter.$t = markType(SectionHeaderCellPresenter, 'SectionHeaderCellPresenter', CellPresenterBase.$);
    return SectionHeaderCellPresenter;
}(CellPresenterBase));
export { SectionHeaderCellPresenter };
//# sourceMappingURL=SectionHeaderCellPresenter.js.map
